import React, { useRef } from "react"
import { PlainTextEditor } from "./PlainTextEditor"

import { createEditor } from "lexical"
import styles from "./styles.module.css"
import { Box } from "@mos-cat/ds"
import { stringToEditorContent } from "@src/utils/editor"
import { MentionNode } from "../../nodes/MentionNode"
import { memo } from "react"
import { useState } from "react"
import { useEffect } from "react"
import { Button } from "@dit/core-frontend"

export const CommentReadComposer = memo(({ text }) => {
  const editorRef = useRef(null)
  const boxRef = useRef(null)
  const [showMore, setShowMore] = useState(false)

  const [isExpanded, setIsExpanded] = useState(false)
  useEffect(() => {
    if (boxRef.current) {
      const height = boxRef.current.offsetHeight
      if (height > 89) {
        setShowMore(true)
      }
    }
  }, [])

  const newEditor = createEditor({
    nodes: [MentionNode],
    disableEvents: false,
    editable: true,
    onError: (err) => console.error(err),
  })
  newEditor.update(() => {
    const editorState = newEditor.parseEditorState(stringToEditorContent(text))
    newEditor.setEditorState(editorState)
  })

  return (
    <Box position="relative">
      <Box ref={boxRef} maxHeight={isExpanded ? "none" : "90px"} overflowY="hidden">
        <PlainTextEditor
          editable={false}
          editorState={newEditor._editorState}
          className={styles.commentRead}
          autoFocus={false}
          onEscape={() => {
            return true
          }}
          editorRef={editorRef}
        />
      </Box>
      {showMore && (
        <Box styles={{ "& *": { transition: "var(--default-transition)" } }}>
          <Button
            marginLeft="20px"
            marginBottom="5px"
            kind="borderless"
            padding="0 !important"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <Box
              width="0"
              height="0"
              borderLeft="4px solid transparent"
              borderRight="4px solid transparent"
              borderTop="8px solid currentColor"
              styles={{ transform: `rotate(${isExpanded ? 180 : 0}deg)` }}
            />

            {isExpanded ? "Показать часть" : "Показать все"}
          </Button>
        </Box>
      )}
    </Box>
  )
})

CommentReadComposer.displayName = "CommentReadComposer"
